module.exports = __webpack_public_path__ + "img/p2-24.0dfda3f6.png";